import React from "react";
import { Layout, Tabs } from "antd";
import { Redirect } from "react-router-dom";
import Logo from "../../../assets/img/png/tec.png";
import RegisterForm from "../../../components/Admin/RegisterForm/RegisterForm"; //vista del formulario
import LoginForm from "../../../components/Admin/LoginForm"; //no se usa de nuevo por el index
import { getAccessTokenApi } from "../../../api/auth";
import "./SignIn.scss";

export default function SingIn() {
  const { Content } = Layout;
  const { TabPane } = Tabs;

  if (getAccessTokenApi()) {
    //funcion si el token es valido no permitira ir a login
    return <Redirect to="/admin" />;
  }
  return (
    <Layout className="sign-in">
      <Content className="sign-in-content">
        <h1 className="sign-in-content-logo">
          <img src={Logo} alt="ISRAEL GARCIA" />
        </h1>

        <div className="sign-in-content-tabs">
          <Tabs type="card">
            <TabPane tab={<span>Entrar</span>} key="1">
              <LoginForm />
            </TabPane>
            <TabPane tab={<span>Nuevo Usuario</span>} key="2">
              <RegisterForm />
            </TabPane>
          </Tabs>
        </div>
      </Content>
    </Layout>
  );
}
